module.exports = {"130224001":"友谊路街道","130224100":"倴城镇","130224101":"宋道口镇","130224102":"长凝镇","130224103":"胡各庄镇","130224104":"坨里镇","130224105":"姚王庄镇","130224106":"司各庄镇","130224107":"安各庄镇","130224108":"扒齿港镇","130224109":"程庄镇","130224110":"青坨营镇","130224111":"柏各庄镇","130224114":"南堡镇","130224115":"方各庄镇","130224116":"东黄坨镇","130224117":"马城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130224.json
// module id = 174
// module chunks = 0